import React, { useState, useEffect } from 'react';
import { lte, equals, not } from 'ramda';
import { InputStyled } from './styles';
import { currencyFormat, currencyGetValue, amountValidRegex } from '../../utils'

const reasonableValidAmount = (amount) => lte(amount, 99000000);

/**
 * @param {*} value - value should be a number
 */
const AmountInput = ({
  value,
  setValue = () => {},
  className = '',
  margin = 'auto'
}) => {

  const [valueDisplayed, setValueDisplayed] = useState();
  const [fontColor, setFontColor] = useState('');

  useEffect(() => {
    setValueDisplayed( currencyFormat(value) );
  }, [])

  useEffect(() => {
    const inputValueRaw = currencyGetValue(valueDisplayed);
    const isZero = equals(inputValueRaw, 0);
    setFontColor(isZero ? '#AAA9A9' : '#6E6E6E');
  }, [valueDisplayed])

  const handleOnChange = (e) => {
    const { value: inputValueRaw } = e.target || null;
    if ( not(amountValidRegex.test( inputValueRaw )) ) return;
    if ( not(reasonableValidAmount( currencyGetValue(inputValueRaw) )) ) return;
    setValue( currencyGetValue(inputValueRaw) );
    setValueDisplayed( inputValueRaw );
  }

  const handleOnFocus = (e) => {
    const { value: inputValueFormatted } = e?.target || null;
    const inputValueRaw = currencyGetValue(inputValueFormatted);
    const isZero = equals(inputValueRaw, 0);
    setValueDisplayed( isZero ? '' : inputValueRaw );
  }

  const handleOnBlur = (e) => {
    const { value: inputValueRaw } = e.target || null;
    setValueDisplayed( currencyFormat(inputValueRaw) )
  }

  return (
    <InputStyled
      className={className}
      boxShadow='none'
      onChange={handleOnChange}
      onBlur={handleOnBlur}
      onFocus={handleOnFocus}
      value={valueDisplayed}
      margin={margin}
      fontColor={fontColor}
    />
  )
}

export default AmountInput;